document.addEventListener('DOMContentLoaded', function () {
   const faqItems = document.querySelectorAll('.faq .item');

   // Inicializa estado
   faqItems.forEach(item => {
      const answer = item.querySelector('.answer');
      if (item.classList.contains('active')) {
         answer.style.display = 'block';
      } else {
         answer.style.display = 'none';
      }

      item.addEventListener('click', function () {
         const isActive = item.classList.contains('active');

         if (isActive) {
            closeFaqItem(item);
         } else {
            closeAllExcept(item);
            openFaqItem(item);
         }
      });
   });

   function closeAllExcept(currentItem) {
      faqItems.forEach(item => {
         if (item !== currentItem && item.classList.contains('active')) {
            closeFaqItem(item);
         }
      });
   }

   function openFaqItem(item) {
      item.classList.add('active');
      const button = item.querySelector('.question button');
      if (button) button.classList.add('active');

      const answer = item.querySelector('.answer');
      if (answer) slideDown(answer);
   }

   function closeFaqItem(item) {
      item.classList.remove('active');
      const button = item.querySelector('.question button');
      if (button) button.classList.remove('active');

      const answer = item.querySelector('.answer');
      if (answer) slideUp(answer);
   }

   // Slide helpers
   function slideUp(element, duration = 300) {
      element.style.height = element.offsetHeight + 'px';
      element.style.transitionProperty = 'height, margin, padding';
      element.style.transitionDuration = duration + 'ms';
      element.style.overflow = 'hidden';
      element.offsetHeight;

      element.style.height = '0';
      element.style.paddingTop = '0';
      element.style.paddingBottom = '0';
      element.style.marginTop = '0';
      element.style.marginBottom = '0';

      setTimeout(() => {
         element.style.display = 'none';
         cleanupTransition(element);
      }, duration);
   }

   function slideDown(element, duration = 300) {
      element.style.removeProperty('display');
      let display = window.getComputedStyle(element).display;
      if (display === 'none') display = 'block';
      element.style.display = display;

      const height = element.scrollHeight + 'px';

      element.style.height = '0';
      element.style.overflow = 'hidden';
      element.style.transitionProperty = 'height, margin, padding';
      element.style.transitionDuration = duration + 'ms';
      element.offsetHeight;

      element.style.height = height;
      element.style.removeProperty('padding-top');
      element.style.removeProperty('padding-bottom');
      element.style.removeProperty('margin-top');
      element.style.removeProperty('margin-bottom');

      setTimeout(() => {
         element.style.removeProperty('height');
         cleanupTransition(element);
      }, duration);
   }

   function cleanupTransition(el) {
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition-duration');
      el.style.removeProperty('transition-property');
   }
});
